//app/javascript/theme/custom.js
// ✅ Load jQuery and expose it globally
import $ from "jquery"
window.$ = $
window.jQuery = $

// Scroll bar
import { OverlayScrollbars } from 'overlayscrollbars';
import 'overlayscrollbars/overlayscrollbars.css';
document.addEventListener("turbo:load", () => {
    const sidebar = document.querySelector(".sidebar-wrapper");
    if (sidebar) {
        OverlayScrollbars(sidebar, {
            scrollbars: {
                theme: 'os-theme-light',
                autoHide: 'leave',
                clickScroll: true,
            },
        });
    }
});


// inputmask
import Inputmask from "inputmask"
// Apply a mask to an input (example)

function applyInputMasks() {
  const inputs = document.querySelectorAll("[data-mask]")

  inputs.forEach(input => {
    const mask = input.getAttribute("data-mask")
    if (mask) {
      Inputmask(mask).mask(input)
    }
  })
}

import * as bootstrap from "bootstrap"
// edit click toogle open
document.addEventListener("turbo:load", () => {
  document.querySelectorAll('.dropdown-toggle').forEach(el => {
    new bootstrap.Dropdown(el)
  })


  // models leaves allownances
  const btn = document.querySelector("[data-leave-balance-url]")
  if (!btn) return
  
  const url = btn.getAttribute("data-leave-balance-url")
  const modalEl = document.getElementById("leaveQuotaModal")
  const modalBody = document.getElementById("leaveQuotaModalBody")
  const modal = new bootstrap.Modal(modalEl)
  
  btn.addEventListener("click", async (e) => {
    // Let BS5 open the modal via data-bs-toggle, we just load content
    modalBody.innerHTML = "<div class='text-muted'>Loading…</div>"
    try {
      const res = await fetch(url, { headers: { Accept: "text/html" } })
      modalBody.innerHTML = await res.text()
      console.log(res);
    } catch {
      modalBody.innerHTML = "<div class='text-danger'>Failed to load quota.</div>"
    }
  });

})

// Apply masks on various Turbo lifecycle events
document.addEventListener("turbo:load", applyInputMasks)
document.addEventListener("turbo:render", applyInputMasks)
document.addEventListener("turbo:frame-load", applyInputMasks)